import React, { FC } from 'react';

const NotFoundPage: FC = () => (
  <div>
    <h4>Not found</h4>
  </div>
);

export default NotFoundPage;
